"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculateCampaignSummaryDto = exports.CampaignDisplayConfigDto = exports.CampaignDateDto = exports.BookingStrategy = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
exports.BookingStrategy = {
    /**
     * (Por defecto) O todo o nada.
     * Si una sola hora de las solicitadas no está disponible, rechaza toda la campaña.
     * Ideal para eventos puntuales que requieren continuidad estricta.
     */
    ALL_OR_NOTHING: "ALL_OR_NOTHING",
    /**
     * "Lo que puedas".
     * Reserva todas las horas disponibles y descarta las que estén llenas.
     * La campaña se aprueba, pero quizás con menos pases de los solicitados.
     * Ideal para campañas de branding largas.
     */
    MAXIMIZE_FILL: "MAXIMIZE_FILL",
};
class CampaignDateDto {
    date;
    hours; // formato HH:MM en segundos
}
exports.CampaignDateDto = CampaignDateDto;
__decorate([
    (0, class_validator_1.IsDateString)({ strict: true }),
    __metadata("design:type", String)
], CampaignDateDto.prototype, "date", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsInt)({ each: true }),
    (0, class_validator_1.Min)(0, { each: true }),
    (0, class_validator_1.Max)(86400, { each: true }),
    __metadata("design:type", Array)
], CampaignDateDto.prototype, "hours", void 0);
// --- 1. Configuración de Excepciones por Pantalla ---
class CampaignDisplayConfigDto {
    /** Opt-in adaptations: validate this screen against its assigned media type. */
    mediaType;
    /**
     * Para pantallas CPM: Límite de impresiones a comprar.
     * Útil para controlar presupuesto en pantallas con mucho tráfico.
     *
     * @deprecated No modifica el pricing. Un futuro límite de impresiones debe
     * aplicarse sobre la campaña completa, no sustituir la audiencia de una hora.
     */
    maxImpressions;
    /**
     * Para pantallas Slots: Forzar la compra de un slot específico.
     * Ej: Si hay slot "Gold" y "Silver", forzar "Gold".
     */
    forceSlotId;
    /**
     * Protección de presupuesto (Bid Cap).
     * Si el precio calculado por pase supera esto, no se incluye la pantalla.
     */
    maxPricePerPlay;
}
exports.CampaignDisplayConfigDto = CampaignDisplayConfigDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(["video", "image"]),
    __metadata("design:type", String)
], CampaignDisplayConfigDto.prototype, "mediaType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], CampaignDisplayConfigDto.prototype, "maxImpressions", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CampaignDisplayConfigDto.prototype, "forceSlotId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], CampaignDisplayConfigDto.prototype, "maxPricePerPlay", void 0);
// --- 2. DTO Principal de Cálculo ---
class CalculateCampaignSummaryDto {
    title;
    displaysIds;
    bookingStrategy = "ALL_OR_NOTHING";
    /**
     * IDs de listas de reproducción (si aplica)
     */
    displayListIds;
    dates;
    mediaType;
    contentType;
    /**
     * CRÍTICO: Duración en segundos del contenido.
     * Base para el cálculo en modelos CPS y Slots.
     */
    duration;
    /**
     * NUEVO: Configuraciones específicas por pantalla.
     * Es un Mapa: { "display_id": { config... } }
     */
    // Nota: Validar Mapas dinámicos en class-validator es complejo,
    // aquí validamos que sea objeto. La lógica interna debe validar los valores.
    displayConfigurations;
    /** All types assigned across rotating creatives. Capacity and price remain one slot. */
    rotationMediaTypesByDisplay;
    /**
     * Códigos de descuento a evaluar en backend.
     *
     * La UI de cliente para introducirlos se implementará más adelante; se deja el contrato
     * preparado para API/admin y para que las reglas auto-apply funcionen sin romper compatibilidad.
     */
    discountCodes;
}
exports.CalculateCampaignSummaryDto = CalculateCampaignSummaryDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.ValidateIf)((o) => !!o.title),
    __metadata("design:type", String)
], CalculateCampaignSummaryDto.prototype, "title", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsNotEmpty)({ each: true }),
    __metadata("design:type", Array)
], CalculateCampaignSummaryDto.prototype, "displaysIds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(["ALL_OR_NOTHING", "MAXIMIZE_FILL"]),
    __metadata("design:type", Object)
], CalculateCampaignSummaryDto.prototype, "bookingStrategy", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], CalculateCampaignSummaryDto.prototype, "displayListIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_validator_1.IsNotEmpty)({ each: true }),
    (0, class_transformer_1.Type)(() => CampaignDateDto),
    __metadata("design:type", Array)
], CalculateCampaignSummaryDto.prototype, "dates", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(["video", "image", "url"]) // Ajusta a tus tipos
    ,
    __metadata("design:type", String)
], CalculateCampaignSummaryDto.prototype, "mediaType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateIf)((o) => o.mediaType === "video" || o.mediaType === "image"),
    (0, class_validator_1.IsIn)(["video/mp4", "video/webm", "image/jpg", "image/png", "image/jpeg", "image/webp"]),
    __metadata("design:type", String)
], CalculateCampaignSummaryDto.prototype, "contentType", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], CalculateCampaignSummaryDto.prototype, "duration", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)()
    // Nota: Validar Mapas dinámicos en class-validator es complejo,
    // aquí validamos que sea objeto. La lógica interna debe validar los valores.
    ,
    __metadata("design:type", Object)
], CalculateCampaignSummaryDto.prototype, "displayConfigurations", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)(),
    __metadata("design:type", Object)
], CalculateCampaignSummaryDto.prototype, "rotationMediaTypesByDisplay", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], CalculateCampaignSummaryDto.prototype, "discountCodes", void 0);
